export default __webpack_public_path__ + "static/220803_天下布魔更新內容預告_jp-10b00f516e76a3c42b0a3803742d06b1.webp";